var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H3C1.3455 0 0 1.3455 0 3V21C0 22.6545 1.3455 24 3 24H21C22.6545 24 24 22.6545 24 21V3C24 1.3455 22.6545 0 21 0Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8211 2.625H8.22422C5.1368 2.625 2.625 5.1368 2.625 8.22422V15.8211C2.625 18.9085 5.1368 21.4203 8.22422 21.4203H15.8211C18.9085 21.4203 21.4203 18.9085 21.4203 15.8211V8.22422C21.4202 5.1368 18.9085 2.625 15.8211 2.625ZM19.5295 15.8211C19.5295 17.8691 17.8691 19.5295 15.8211 19.5295H8.22422C6.17613 19.5295 4.5158 17.8691 4.5158 15.8211V8.22422C4.5158 6.1761 6.17613 4.5158 8.22422 4.5158H15.8211C17.8691 4.5158 19.5295 6.1761 19.5295 8.22422V15.8211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 7.16162C9.34208 7.16162 7.16138 9.34232 7.16138 12.0227C7.16138 14.7031 9.34208 16.8838 12.0225 16.8838C14.7029 16.8838 16.8836 14.7031 16.8836 12.0227C16.8836 9.34228 14.7029 7.16162 12.0225 7.16162ZM12.0225 14.9931C10.382 14.9931 9.05218 13.6632 9.05218 12.0227C9.05218 10.3823 10.3821 9.05242 12.0225 9.05242C13.663 9.05242 14.9928 10.3823 14.9928 12.0227C14.9928 13.6632 13.663 14.9931 12.0225 14.9931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8933 8.36286C17.5367 8.36286 18.0582 7.84135 18.0582 7.19803C18.0582 6.55471 17.5367 6.0332 16.8933 6.0332C16.25 6.0332 15.7285 6.55471 15.7285 7.19803C15.7285 7.84135 16.25 8.36286 16.8933 8.36286Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4.82813,
    y1: 24,
    x2: 24,
    y2: 0.703125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7953,
    height: 18.7953,
    fill: "white",
    transform: "translate(2.625 2.625)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.93a26ab3ff995cd003a56c7ec984b942.svg";
export { ForwardRef as ReactComponent };